<template>
	<layout-admin-basic class="admin-static-content static-content-terms">
		<div slot="breadcrumbs"><admin-breadcrumbs :breadcrumbs="breadcrumbs"/></div>
		<span slot="header">{{ title }}</span>

		<input-select v-model="selectedRoute" :options="routeOptions" name="route_name" placeholder="Route" rules="required"/>
		<br>

		<spinner v-if="collection.loading"/>
		<error-box v-if="collection.error" :error="collection.error"/>
		<form v-if="!collection.loading && collection.data.length" @submit.prevent="validateAndSubmit">
			<div class="tab">
				<button class="tablinks" v-for="item in collection.data" :key="item.id" @click.prevent="openTab(item.id)">
					<shape :src="shapeSrc(item.lang)" class="flag" :class="{ selected: isSelected(item.id) }"/>
					<span>{{ item.lang }}</span>
				</button>
			</div>
			<div class="tabcontent" v-for="(item, index) in collection.data" :key="item.id" v-show="isSelected(item.id)">
				<input-textarea v-model="collection.data[index].content" name="admin_help"/>
			</div>
			<br>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
		<!--pre>{{ routes }}</pre>
		<pre>{{ selectedRoute }}</pre>
		<pre>{{ collection }}</pre>
		<pre>{{ selectedContent }}</pre>
		<pre>{{ form }}</pre-->
	</layout-admin-basic>
</template>

<script>
import LayoutAdminBasic from '../LayoutAdminBasic'
import AdminBreadcrumbs from '../AdminBreadcrumbs'
import ApiCollection from '@/classes/api/ApiCollection'
import FormObject from '@/classes/api/FormObject'
export default {
	components: {
		LayoutAdminBasic,
		AdminBreadcrumbs
	},
	data () {
		return {
			title: 'Help Pages',
			routes: new ApiCollection(),
			selectedRoute: null,
			collection: new ApiCollection(),
			form: new FormObject(),
			selectedContent: null,
			flags: new Map([
				['en-gb', '/static/svg/flags/uk.svg'],
				['fr',    '/static/svg/flags/fr.svg'],
				['pt',    '/static/svg/flags/pt.svg']
			])
		}
	},
	computed: {
		breadcrumbs () {
			return [
				{
					title: this.title
				}
			]
		},
		routeOptions () {
			return this.routes.data.map(ele => {
				return { value: ele,  text: ele }
			})
		}
	},
	watch: {
		selectedRoute (value) {
			this.getCollection()
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.editItem()
				})
		},
		getRouteNames () {
			this.routes.loading = true
			this.$api.help.getHelpContentRouteNames(this)
				.then(response => {
					this.$log.info('admin', 'help.getHelpContentRouteNames OK', response)()
					this.routes.data = response.body.length ? response.body : []
				})
				.catch(error => {
					this.$log.error('admin', 'help.getHelpContentRouteNames ERROR', error)()
					this.routes.error = error
				})
				.finally(() => {
					this.routes.loading = false
				})
		},
		getCollection () {
			this.collection.loading = true
			this.$api.help.getHelpContent(this, this.selectedRoute)
				.then(response => {
					this.$log.info('admin', 'help.getHelpContent OK', response)()
					this.collection.data = response.body.length ? response.body : []
					if (this.collection.data.length) {
						this.collection.data.sort((a, b) => {
							if (a.lang < b.lang) return -1
							if (a.lang > b.lang) return 1
							return 0
						})
						this.selectedContent = this.collection.data[0].id
					}
				})
				.catch(error => {
					this.$log.error('admin', 'help.getHelpContent ERROR', error)()
					this.collection.error = error
				})
				.finally(() => {
					this.collection.loading = false
				})
		},
		editItem () {
			this.form.loading = true
			this.$api.help.editHelpContent(this, this.selectedRoute, this.collection.data)
				.then(response => {
					this.$log.info('admin', 'help.editHelpContent OK', response)()
				})
				.catch(error => {
					this.$log.error('admin', 'help.editHelpContent ERROR', error)()
					this.form.error = error
				})
				.finally(() => {
					this.form.loading = false
					this.getCollection()
				})
		},
		openTab (value) {
			this.selectedContent = value
		},
		shapeSrc (value) {
			return this.flags.get(value)
		},
		isSelected (value) {
			return this.selectedContent == value
		}
	},
	mounted () {
		this.getRouteNames()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/help/AdminHelpContent.vue